import React, { useContext } from 'react'
import ImgBgLight from 'resources/images/logo_amsweb_light.png'
import ImgBgDark from 'resources/images/logo_amsweb_dark.png'
import LightDarkContext from 'context/LightDarkModeContext'

const Start = () => {
  const { mode } = useContext(LightDarkContext)
  return (
    <div
      style={{
        background: `url(${mode === 'light' ? ImgBgLight : ImgBgDark}) no-repeat center center fixed`,
        width: '100%',
        height: '100rex',
        backgroundColor: mode === 'light' ? 'white' : 'rgb(0, 32, 96)',
        flex: 1,
      }}
    />
  )
}

export default Start
